( function ( $ ) {
  document.addEventListener ( 'DOMContentLoaded', function( event ) {
    const loader = $('#loader');
    if (loader.length) {
      $(document).ajaxStart(function() {
        loader.show();
      });

      $(document).ajaxStop(function() {
        loader.hide();
      });
    }
  } );
} ) ( jQuery );
